import DragHandleIcon from "@mui/icons-material/DragHandle";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import { styled } from "@mui/material";

import type {
  StyledConstantsDragHandleIconAlternateProps,
  StyledConstantsDragHandleIconProps,
  StyledConstantsKeyboardDoubleArrowDownIconAlternateProps,
  StyledConstantsKeyboardDoubleArrowDownIconProps,
  StyledConstantsKeyboardDoubleArrowUpIconAlternateProps,
  StyledConstantsKeyboardDoubleArrowUpIconProps,
} from "./types";

export const StyledConstantsKeyboardDoubleArrowDownIcon = styled(
  KeyboardDoubleArrowDownIcon,
  {
    shouldForwardProp: (prop) =>
      !["taskPriorityToColorMapTaskPriorityEnumLOW"].includes(String(prop)),
  }
)<StyledConstantsKeyboardDoubleArrowDownIconProps>(
  ({ taskPriorityToColorMapTaskPriorityEnumLOW }) => ({
    color: taskPriorityToColorMapTaskPriorityEnumLOW,
    width: "22px",
    height: "22px",
    path: {
      fill: `${taskPriorityToColorMapTaskPriorityEnumLOW} !important`,
    },
  })
);

export const StyledConstantsDragHandleIcon = styled(DragHandleIcon, {
  shouldForwardProp: (prop) =>
    !["taskPriorityToColorMapTaskPriorityEnumMED"].includes(String(prop)),
})<StyledConstantsDragHandleIconProps>(
  ({ taskPriorityToColorMapTaskPriorityEnumMED }) => ({
    color: taskPriorityToColorMapTaskPriorityEnumMED,
    width: "22px",
    height: "22px",
    path: {
      fill: `${taskPriorityToColorMapTaskPriorityEnumMED} !important`,
    },
  })
);

export const StyledConstantsKeyboardDoubleArrowUpIcon = styled(
  KeyboardDoubleArrowUpIcon,
  {
    shouldForwardProp: (prop) =>
      !["taskPriorityToColorMapTaskPriorityEnumHIGH"].includes(String(prop)),
  }
)<StyledConstantsKeyboardDoubleArrowUpIconProps>(
  ({ taskPriorityToColorMapTaskPriorityEnumHIGH }) => ({
    color: taskPriorityToColorMapTaskPriorityEnumHIGH,
    width: "22px",
    height: "22px",
    path: {
      fill: `${taskPriorityToColorMapTaskPriorityEnumHIGH} !important`,
    },
  })
);

export const StyledConstantsKeyboardDoubleArrowDownIconAlternate = styled(
  KeyboardDoubleArrowDownIcon,
  {
    shouldForwardProp: (prop) =>
      !["taskPriorityToColorMapTaskPriorityEnumLOW"].includes(String(prop)),
  }
)<StyledConstantsKeyboardDoubleArrowDownIconAlternateProps>(
  ({ taskPriorityToColorMapTaskPriorityEnumLOW }) => ({
    color: taskPriorityToColorMapTaskPriorityEnumLOW,
    width: "16px",
    height: "16px",
    path: {
      fill: `${taskPriorityToColorMapTaskPriorityEnumLOW} !important`,
    },
  })
);

export const StyledConstantsDragHandleIconAlternate = styled(DragHandleIcon, {
  shouldForwardProp: (prop) =>
    !["taskPriorityToColorMapTaskPriorityEnumMED"].includes(String(prop)),
})<StyledConstantsDragHandleIconAlternateProps>(
  ({ taskPriorityToColorMapTaskPriorityEnumMED }) => ({
    color: taskPriorityToColorMapTaskPriorityEnumMED,
    width: "16px",
    height: "16px",
    path: {
      fill: `${taskPriorityToColorMapTaskPriorityEnumMED} !important`,
    },
  })
);

export const StyledConstantsKeyboardDoubleArrowUpIconAlternate = styled(
  KeyboardDoubleArrowUpIcon,
  {
    shouldForwardProp: (prop) =>
      !["taskPriorityToColorMapTaskPriorityEnumHIGH"].includes(String(prop)),
  }
)<StyledConstantsKeyboardDoubleArrowUpIconAlternateProps>(
  ({ taskPriorityToColorMapTaskPriorityEnumHIGH }) => ({
    color: taskPriorityToColorMapTaskPriorityEnumHIGH,
    width: "16px",
    height: "16px",
    path: {
      fill: `${taskPriorityToColorMapTaskPriorityEnumHIGH} !important`,
    },
  })
);
